import {HttpClient} from '@angular/common/http';
import {Component, HostListener, NgZone, OnInit} from '@angular/core';
import {ApiResponse} from '../../classes/api-response';
import {environment} from 'src/environments/environment';
import {AuthService} from 'src/app/services/auth.service';
import {Router} from '@angular/router';
import {Constants} from '../../utils/constants';
import {SnackService} from 'src/app/services/snack.service';

@Component({
  selector: 'aw-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
})
export class EmailVerificationComponent implements OnInit {

  errorMessageText = "The token you inserted is not correct";
  completed = true;
  tokenText = '';
  private readonly errorMessage1 = 'Our Services are momentarily unavailable.';
  private readonly errorMessage2 = 'The token you inserted is not correct.';
  private readonly emailSentMessage = "The email has been sent!";
  private readonly ctrlFullPathVerification = `${environment.apiUrl}/public/email-verification`;
  private readonly requestNewEmail = `${environment.apiUrl}/common-user`;

  constructor(private httpClient: HttpClient,
              public authService: AuthService,
              public snackBarService: SnackService,
              private router: Router,
              private ngZone: NgZone,) {

  }

  onResendEmailButtonClicked(): void {
    this.completed = false;
    console.log(`calling get ${this.requestNewEmail}`);
    this.httpClient.get<ApiResponse>(this.requestNewEmail)
      .subscribe(
        (data) => {
          if (data.data == Constants.apiResponses.tokenValid) {
            window.location.href = '/reserved';
            return;
          }
          this.snackBarService.info(this.emailSentMessage);
          this.completed = true;
        },
        () => {
          this.snackBarService.error(this.errorMessage1);
          this.completed = true;
        });
  }

  @HostListener('document:keydown.enter')
  onVerifyButtonClicked(): void {

    if (!this.completed) return;

    const body = {
      token: this.tokenText.trim()
    };
    console.log(`calling post ${this.requestNewEmail}`);


    this.completed = false;
    this.httpClient
      .post<ApiResponse>(this.ctrlFullPathVerification, body)
      .subscribe((data) => {
          this.completed = true;
          if (data.data === Constants.apiResponses.tokenIncorrect) {
            this.snackBarService.error(this.errorMessage2);
          } else if (data.data === Constants.apiResponses.tokenCorrect || data.data === Constants.apiResponses.tokenValid) {
            window.location.href = '/reserved';
          }
        },
        () => {
          this.snackBarService.error(this.errorMessage1);
          this.completed = true;
        });
  }

  ngOnInit(): void {
    this.onResendEmailButtonClicked();
  }
}
